let _this;
import qs from 'qs'
export default {
  name: "same-user-detected",
  props:['userInfo','userType','userACData','tempAccessData'],
  data(){
    return{
      idSearchModal:false,
      enablePDPA:this.ApiService.identityInfo.isEnablePDPA,/*是否启用PDPA*/
      keepFigures:this.ApiService.identityInfo.keepFigures,/*ID保留位数*/
      sameIdList:[],/*共同ID集合*/
      replaceInfo:{},
      replaceTipModal:false,

      titleData:[{
        title: 'Update Field',
        key: 'title',
        minWidth: 150,
      },{
        title: 'Old Value',
        slot: 'oldValue',
        minWidth: 150,
      },{
        title: 'New Value ',
        slot: 'newValue',
        minWidth: 150,
      }],
      tableData:[],
      basicFields:{'tags':'Tag','faceFileBase64':'Face','faceFileId':'Face','name':'Name','addIdentityCards':'ID No.','departmentName':'Department','validityStartTime':'Validity','contact':'Contact','email':'Email','remarks':'Remarks','status':'Status','cards':'Card No.','accessRule':'Access Rule'},
      dataList:[{label:'oldValue',value:'userInfo'},{label:'newValue',value:'replaceInfo'}]
    }
  },
  mounted(){
    _this = this;
  },
  methods:{
    // 展开相同内容
    expandContent:function (e) {
      $(e.target).parents('.details-box-option').find('.details-module-content').slideToggle(300);
      $(e.target).parents('.details-box-option').find('.ivu-icon-ios-arrow-up').toggleClass('rotate');
    },
    // 信息替换
    uploadInfo:function (user) {
      this.replaceInfo = JSON.parse(JSON.stringify(user));
      let userUpdateInfo = this.userInfo;
      // 将需要替换的userId赋值
      if(_this.$route.query && _this.$route.query.userId){
        userUpdateInfo.id = _this.$route.query.userId;
      }
      userUpdateInfo.customFields = _this.customFields;
      userUpdateInfo.userACData = _this.userACData;
      userUpdateInfo.tempAccessData = _this.tempAccessData;
      if(userUpdateInfo.cardId){
        _this.$ajax.get('SystemSetting/GetNodeSettings?queryNodeId=' + user.buildingId + '&keys=system.setting.node.user.type.use.tags', { headers: { noLoading: true } }).then(function (res) {
          if (res.data.success) {
            let sysUserTags = res.data.data['system.setting.node.user.type.use.tags'];
            judgeCardisTransfer(sysUserTags);
          }
        });
        function judgeCardisTransfer(sysUserTags){
          _this.$ajax.get('Card/QueryCardDetail?id=' + userUpdateInfo.cardId).then(res => {
            if (res.data.success && res.data.data) {
              let curCarddTags = res.data.data.tags.map(item => item.name);
              localStorage.setItem('userUpdateInfo',JSON.stringify(userUpdateInfo));
              // 判断新的卡tag是否存在于跳转的user类型卡tag中
              let obj = { '0': 'Staff', '1': 'Visitor', '2': 'Vendor', '3': 'Tenant' };
              let userCardTags = sysUserTags[obj[_this.replaceInfo.userType]];
              let flag = curCarddTags.find(item => userCardTags.includes(item));
              console.log(userCardTags,flag);
              if (userCardTags && userCardTags.length > 0 && !flag) {
                userUpdateInfo.cardId = null;
                userUpdateInfo.cardNo = null;
              }
              localStorage.setItem('userUpdateInfo',JSON.stringify(userUpdateInfo));
            }
          })
        }
      }else{
        localStorage.setItem('userUpdateInfo',JSON.stringify(userUpdateInfo));
      }

      // 获取新旧信息对比
      _this.$set(_this,'tableData',[]);
      _this.icReplace('userInfo');
      _this.icReplace('replaceInfo');
      for(let key in _this.basicFields){
        if(((Array.isArray(_this.userInfo[key]) && _this.userInfo[key].length > 0) || (!Array.isArray(_this.userInfo[key]) && (_this.userInfo[key] || _this.userInfo[key] === 0 || _this.userInfo[key] === false)))){
          _this.tableData.push({title:_this.basicFields[key],field:key,oldValue:'',newValue:''});
        }
      }
      setTimeout(function(){
        _this.replaceTipModal = true;
      },400);
    },
    icReplace(obj){
      //IC
      _this.$set(_this[obj],'icInfo',{viewIC:'',others:[]});
      let array = [];
      if(_this[obj].addIdentityCards && _this[obj].addIdentityCards.length > 0){
        array = _this[obj].addIdentityCards;
      }else if(_this[obj].identifyCardResults && _this[obj].identifyCardResults.length > 0){
        array = _this[obj].identifyCardResults;
      }
      array.forEach((ic,index) =>{
        if(index === 0){
          _this[obj].icInfo.viewIC = _this.common.icType[ic.type].label + ' - ' + ic.no.replace(/\*/g,'');
        }
        else{
          _this[obj].icInfo.others.push(_this.common.icType[ic.type].label + ' - ' + ic.no.replace(/\*/g,''));
        }
      })

      _this.shareApi.getImgUrl(_this[obj].faceFileId).done(str =>{
        _this[obj].faceFileBase64 = str;
      })
    },
    // 确认替换
    confirmReplace:function () {
      let path = {'0':'editStaff','1':'editVisitor','2':'editVendor','3':'editTenant'};
      _this.$router.push({path:path[this.replaceInfo.userType],query:{userId:this.replaceInfo.id}});
    },
    // 更多信息
    viewMoreInfo:function (e,type) {
      if(type === 0){
        $(e.target).parents('.user-more-option').find('.other-option-box').css({'left':e.pageX - e.offsetX,'top':e.pageY - e.offsetY + 21,'display':'block'});
      }else{
        $(e.target).find('.other-option-box').css({'left':e.pageX,'top':e.pageY,'display':'none'});
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/userCommon/userDetectionByFace.js